import { adsMidBlueA } from "../utils/ADSColours";

const InterestType = [
  {
    id: 1,
    gpText: "Primary Notice Authority",
    osText: undefined,
    colour: adsMidBlueA,
    default: false,
  },
  {
    id: 8,
    gpText: "All notices",
    osText: undefined,
    colour: adsMidBlueA,
    default: false,
  },
  {
    id: 9,
    gpText: "Restrictions or licences",
    osText: undefined,
    colour: adsMidBlueA,
    default: false,
  },
];

export default InterestType;
